var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__wrapper",on:{"scroll":function($event){return _vm.onScroll()}}},[_c('FCSpecs',{attrs:{"h2":this.h2,"h3":this.h3,"specs":this.benefits}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }